import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { AlertService } from '../core';
import { ErrorHelper } from '../identity/helpers/error.helper';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
	constructor(private alertService: AlertService) {}

	intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		return next.handle(request).pipe(
			catchError((error: unknown) => {
				if (error['isAuthorizationError'] !== true) {
					this.alertService.addError(ErrorHelper.extractMessage(error));
				}

				return throwError(error);
			})
		);
	}
}
